import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      backgroundColor: palette.common.white,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      width: '245px',
      borderRadius: '0 30px 30px 0',
      boxSizing: 'border-box',
      padding: '20px',
      height: '100vh',
      minHeight: 'calc(735px - 5vh)',
      gap: '20px',
      boxShadow: palette.shadows.boxShadow
    },
    content: {
      marginRight: '10px',
      marginLeft: '10px'
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
